import styled from 'styled-components'

export const ServiceCardContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
